import React from "react";
import Layout from "../../shared/Layout/Layout";
import logo from "../../assets/logo.png";
import styles from "./Terms.module.scss";

const Terms = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.banner}>
            <div className={styles.overlay}></div>
            <h1>
              Terms & <br /> Condition
            </h1>
          </div>

          <main className={styles.main}>
            <div className={styles.left}>
              <ul>
                <li className={styles.active}>Terms Of Usage</li>
                <li>Legal Service</li>
                <li>About Us</li>
              </ul>
            </div>
            <div className={styles.right}>
              <img src={logo} alt="logo" />
              <h2>Our Terms</h2>
              <h4>General</h4>
              <p>
                We may collect your personal data from direct and indirect
                interactions with you to provide our services as agreed by you
                or to fulfill our contractual obligations with you.
              </p>

              <p>
                In this regard we may gather personal data that may include
                your:
                <br />
                <br />
                Name, address, nationality, email address, telephone number,
                bank account details, job title, name of employer, bank account
                details, tax ID or your national insurance number, forms of
                identification.
              </p>

              <p>
                We may use this information to:
                <br />
                <br />
                Set up meetings with you, maintain a record of your contacts,
                respond to your enquiries and fulfill your requests, assist you
                with your transactions or provide you with investor related
                services.
                <br />
                <br />
                The use and processing of your personal data is necessary for
                our legitimate interests in providing our services, carrying out
                of administrative duties, the running of our business and in
                order to make or advise on investment decisions.
              </p>
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
};

export default Terms;
